export class AddLogNotificationRequestDto {
    receivingAdministratorId!: string;
    logEntryTypeId!: string;
    logNotificationTypeId!: string;
}